import {
  Supertype,
  supertypeClass,
  property,
  remote,
  Remoteable,
  Persistable,
  amorphicStatic,
} from '@haventech/amorphic';
import {
  IsomorphicPersistent,
  Persistent,
  IsomorphicQuery,
  Query,
  Isomorphic,
  Serializable,
  AppController,
  SubController,
  Everything,
} from '@hit/amorphic-types';
import { Expense } from './Expense';
import { CashFlow } from './CashFlow';

@supertypeClass({ toClient: true, toServer: true })
export class Children extends Expense {
  @property({ rule: ['numeric'], validate: 'isWithinAge(0, 21);isWithin(0, 21)' })
  age: number = 2;

  @property()
  name: string;

  @property()
  period: number;

  constructor() {
    super();
  }

  static new(customer, age) {
    return new Children().init(customer, age);
  }

  init(customer, age) {
    super.init(customer, 'children', 1, 'College');

    this.age = age;
    return this;
  }

  isActive() {
    return this.customer.profile.collegeType !== 'none';
  }

  getEndYear() {
    const costs = this.customer.assumptions.collegeCosts[this.customer.profile.collegeType];

    return this.getStartYear() + Math.min(this.customer.profile.collegeMaxYears, costs.period) - 1;
  }

  calculateCost() {
    if (this.customer.profile.collegeType === 'none') {
      this.period = 4;
      this.amount = 0;
      return;
    }

    const costs = this.customer.assumptions.collegeCosts[this.customer.profile.collegeType];
    const profile = this.customer.profile;

    this.period = costs.period;
    this.amount = profile.getCollegeCost();
  }

  getStartYear() {
    return Math.max(this.customer.assumptions.startCollege - this.age, 0);
  }

  getDescription() {
    return 'College<br />' + this.getChildSequence();
  }

  getChildSequence() {
    for (let ix = 0; ix < this.customer.capitalNeeds.children.length; ++ix) {
      if (this.customer.capitalNeeds.children[ix] === this) {
        return 'chld' + (ix + 1);
      }
    }
  }

  getFutureValue() {
    this.calculateCost();

    if (this.amount === 0) {
      return 0;
    }

    let total = 0;

    for (let year = this.getStartYear(); year <= this.getEndYear(); ++year) {
      total += this.amount * Math.pow(1 + this.customer.settings.collegeInflation, year);
    }

    return total;
  }

  getStartingFlow(deceased) {
    this.calculateCost();

    return super.getStartingFlow(deceased);
  }

  adjustFlow(flow) {
    flow.amount += flow.amount * this.customer.settings.collegeInflation;
  }
}
